const setErrorOnInternalServer = (state, payload) => {
  state.errors.errorOnInternalServer = payload
}

export default {
  setErrorOnInternalServer,
}
